function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.796 12h-9.592c-.86 0-1.319 1.012-.753 1.659l4.796 5.48a1 1 0 001.506 0l4.796-5.48c.566-.647.106-1.659-.753-1.659z",
  fill: "#29354C"
});

var SvgIconIndexDown = function SvgIconIndexDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwLjc5NjIgMTJIMTEuMjAzOEMxMC4zNDQ2IDEyIDkuODg1NDMgMTMuMDExOSAxMC40NTEyIDEzLjY1ODVMMTUuMjQ3NCAxOS4xMzk5QzE1LjY0NTggMTkuNTk1MiAxNi4zNTQyIDE5LjU5NTIgMTYuNzUyNiAxOS4xMzk5TDIxLjU0ODggMTMuNjU4NUMyMi4xMTQ2IDEzLjAxMTkgMjEuNjU1NCAxMiAyMC43OTYyIDEyWiIgZmlsbD0iIzI5MzU0QyIvPgo8L3N2Zz4K";
export { SvgIconIndexDown as ReactComponent };